import React, { useEffect } from 'react';

import { useFormState } from 'react-final-form';

import { ImportTestCasesStatusContext } from '@qality/common-components/src/lib/ImportTestCasesStatusProvider';
import { ProjectIssueTypesContext } from '@qality/common-components/src/lib/ProjectIssueTypesProvider';

import { ImportView } from './Import.view';

export const Import = () => {
  const { projectIssueTypes } = React.useContext(ProjectIssueTypesContext);
  const { importTestCases } = React.useContext(ImportTestCasesStatusContext);
  const { values } = useFormState();

  useEffect(() => {
    importTestCases(
      values.project?.id,
      values.mapping,
      values.file?.csv.data,
      projectIssueTypes,
      values.delimiter.value
    );
  }, []);

  return (
    <ImportView
      projectId={values.project?.id}
      mapping={values.mapping}
      data={values.file?.csv.data}
      qalityTestFields={[]}
    />
  );
};
